function CentralAfricanRepublic({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_880)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M30.0545 8.34779C27.987 4.55848 24.4318 1.69792 20.1739 0.550293L19.4783 8.34779H30.0545Z" fill="#0052B4"/>
  <path d="M1.94543 8.34779H12.5217L11.8261 0.550293C7.56812 1.69792 4.013 4.55854 1.94543 8.34779V8.34779Z" fill="#0052B4"/>
  <path d="M19.4783 16V23.6522H30.0545C31.2948 21.379 32 18.7719 32 16H19.4783Z" fill="#6DA544"/>
  <path d="M12.5218 16H0C0 18.7719 0.705188 21.379 1.94544 23.6522H12.5217V16H12.5218Z" fill="#6DA544"/>
  <path d="M1.94543 23.6523C4.013 27.4417 7.56812 30.3022 11.8261 31.4498L12.5217 24.6305L1.94543 23.6523Z" fill="#FFDA44"/>
  <path d="M20.1739 31.4498C24.4318 30.3022 27.987 27.4417 30.0545 23.6523L19.4783 24.6304L20.1739 31.4498Z" fill="#FFDA44"/>
  <path d="M19.4783 24.6304L30.0546 23.6523H19.4783V24.6304Z" fill="#FFDA44"/>
  <path d="M12.5218 23.6523H1.94543L12.5218 24.6304V23.6523Z" fill="#FFDA44"/>
  <path d="M16 0C14.5558 0 13.1569 0.1925 11.826 0.551188V31.4489C13.1569 31.8075 14.5558 32 16 32C17.4442 32 18.843 31.8075 20.1739 31.4488V0.551188C18.843 0.1925 17.4442 0 16 0V0Z" fill="#D80027"/>
  <path d="M8.60609 3.47803L9.03771 4.80659H10.4348L9.30465 5.62771L9.73634 6.95628L8.60609 6.13521L7.4759 6.95628L7.90771 5.62771L6.77759 4.80659H8.17453L8.60609 3.47803Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default CentralAfricanRepublic;
